// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref } from "firebase/database";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDmIMPF2k8dq-GkjfvqJ0lFgrAWyG6_ZgA",
  authDomain: "turnero-citroen.firebaseapp.com",
  databaseURL: "https://turnero-citroen-default-rtdb.firebaseio.com",
  projectId: "turnero-citroen",
  storageBucket: "turnero-citroen.appspot.com",
  messagingSenderId: "531491785410",
  appId: "1:531491785410:web:2689cfa9d8d3f2929c095b",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const dbRef = ref(db);
const auth = getAuth(app);
// nombres de colecciones
const turnos = "turnos";
const usuarios = "usuarios";
const mecanicos = "mecanicos";
const tiposTurno = "configuracion/tipos_turno";
const estadosTurno = "configuracion/estados_turno";
const horariosTurno = "configuracion/horarios_turno";
// referencias a colecciones
const refTurnos = ref(db, turnos);
const refUsuarios = ref(db, usuarios);
const refMecanicos = ref(db, mecanicos);
const refTiposTurno = ref(db, tiposTurno);
const refEstadosTurno = ref(db, estadosTurno);
const refHorariosTurno = ref(db, horariosTurno);

export {
  db,
  dbRef,
  auth,
  turnos,
  usuarios,
  mecanicos,
  tiposTurno,
  estadosTurno,
  horariosTurno,
  refTurnos,
  refUsuarios,
  refMecanicos,
  refTiposTurno,
  refEstadosTurno,
  refHorariosTurno,
};
